<template>
  <div class="date">{{ model }}</div>
</template>

<script>
export default {
  name: "date",
  data() {
    return {
      model: null
    };
  },
  props: ["input", "form", "rowdata"],
  created() {
    this.model = this.rowdata;
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style>
.date {
  font-size: 10px;
  white-space: pre;
}
</style>
